import * as React from 'react';

import { LocalizedText } from 'bernie-l10n';
import { ViewMedium, Viewport, ViewSmall } from 'bernie-view';

import { RoomViewModel } from 'models';

import { UitkIcon, UitkIconSize } from 'uitk-react-icons';

import { RoomInfo } from 'components/infosite/rooms-and-rates/room-info';

export interface RoomDetailsInfoDialogLinkProps {
  className?: string;
  dataStid?: string;
  position?: string;
  room: RoomViewModel;
}

export class RoomDetailsInfoDialogLink extends React.Component<RoomDetailsInfoDialogLinkProps> {
  public render() {
    const { className, dataStid, position, room } = this.props;

    return (
      <RoomInfo
        className={className}
        data-stid={dataStid}
        position={position}
        room={room}
        trackingRfrr={`.RoomInfo${position}`}
        width="full"
      >
        <Viewport>
          <ViewSmall>
            <RenderInfoDialogContent className={'all-grid-align-end'} />
          </ViewSmall>
          <ViewMedium>
            <RenderInfoDialogContent />
          </ViewMedium>
        </Viewport>
      </RoomInfo>
    );
  }
}

interface RenderInfoDialogContentProps {
  className?: string;
}

const RenderInfoDialogContent = ({ className = '' }: RenderInfoDialogContentProps) => (
  <React.Fragment>
    <span className={`${className} infoicon__more uitk-grid uitk-type-300 all-t-padding-four`}>
      <LocalizedText message="hotels.infosite.rateInfo.moreDetails.linkText" />
      <UitkIcon className="all-b-margin-half" name="navigate_next" size={UitkIconSize.SMALL} />
    </span>
  </React.Fragment>
);
